import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Brush,
  Legend,
} from "recharts";
import { useMediaQuery } from "react-responsive";
import { ChartWrapper } from "../components/ChartWrapper";
import { formatNumber } from "../../utils/number";
import { formatLabel } from "../../utils/string";

// 🔥 smart label
const renderSmartLabel = (data, key) => (props) => {
  const { x, y, width, height, index,value } = props;
  

  if (!value || value === 0) return null;

  if (height < 18) {
    return (
      <text
        x={x + width / 2}
        y={y - 4}
        fill="#111"
        textAnchor="middle"
        fontSize={12}
        fontWeight="600"
      >
        {formatNumber(value)}
      </text>
    );
  }

  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize={12}
      fontWeight="700"
    >
      {formatNumber(value)}
    </text>
  );
};

export default function ProgressReport({ data = [], loading }) {
  const isSmall = useMediaQuery({ query: "(max-width: 600px)" });

  return (
    <ChartWrapper
      title="Progress Report"
      subtitle="Comparison of attempted and pending questions "
      loading={loading}
      height={360}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            barCategoryGap={isSmall ? "10%" : "15%"}
            margin={{
              top: 30,
              right: 20,
              left: 20,
              bottom: 50,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

            {/* X Axis */}
            <XAxis
              tickFormatter={value => formatLabel(value)}
              dataKey="Subject"
              interval={0}
              tick={{
                fontSize: isSmall ? 11 : 13,
                fill: "#222",
                fontWeight: 600,
              }}
              axisLine={{ stroke: "#9ca3af", strokeWidth: 1.2 }}
              tickLine={false}
              angle={isSmall ? -25 : 0}
              textAnchor={isSmall ? "end" : "middle"}
            />

            {/* Y Axis with formatter */}
            <YAxis
              tick={{
                fontSize: 12,
                fill: "#222",
                fontWeight: 600,
              }}
              tickFormatter={(value) => formatNumber(value)} // 🔥 HERE
              axisLine={{ stroke: "#9ca3af", strokeWidth: 1.2 }}
              tickLine={false}
              width={55}
              label={{
                value: "Questions",
                angle: -90,
                 dx: -25, 
                position: "outsideLeft",
                style: {
                  fontSize: 13,
                  fontWeight: 700,
                  fill: "#111",
                },
              }}
            />

            {/* Tooltip */}
            <Tooltip
              contentStyle={{
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                fontSize: "13px",
              }}
            />

            {/* 🔥 Brush */}
            <Brush
              dataKey="Subject"
              height={10}
              endIndex={
                data.length > 0 ? Math.min(Math.abs(data.length - 1), 3) : 1
              }
              stroke="#6b7280"
            />

            {/* Attempted */}
            <Bar
              dataKey="Attempted"
              fill="#3b82f6"
              maxBarSize={50} // 🔥 bigger bars
            >
              <LabelList content={renderSmartLabel(data, "Attempted")} />
            </Bar>
            {/* Pending */}
            <Bar dataKey="Pending" fill="#6b7280" maxBarSize={50}>
              <LabelList content={renderSmartLabel(data, "Pending")} />
            </Bar>
             <Legend
              wrapperStyle={{
                fontSize: "16px",
                fontWeight: 600,
                paddingTop: 10,
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </ChartWrapper>
  );
}
